import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/ui/Button';
import Typography from 'components/ui/Typography';
import { layout } from 'styles';
import CopyButton from 'components/CopyButton';

import css from './ErrorPage.module.scss';

interface Props {
    retryHandler?: () => void;
    errorMsg?: string;
}

const Error500Internal: React.FC<Props> = ({ retryHandler, errorMsg }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className={`${layout.flexColCenter} ${layout.gap2}`}>
                <Typography style="HeadLargeBold" align="center">
                    {t('ErrorInfo.Error500Label')}
                </Typography>
                <Typography style="BodyLargeNormal" align="center">
                    {t('ErrorInfo.SomethingHappened')}
                </Typography>
            </div>
            {errorMsg && (
                <>
                    <div className={css.errorMessage}>
                        <CopyButton text={errorMsg}>
                            <Typography>{errorMsg}</Typography>
                        </CopyButton>
                    </div>
                </>
            )}
            {retryHandler && (
                <div className={css.content}>
                    <Button withPadding onClick={retryHandler} color="pale">
                        {t('Loader.Retry')}
                    </Button>
                </div>
            )}
        </>
    );
};

export default Error500Internal;
